module.exports = __webpack_public_path__ + "static/media/mypic.bee439cd.png";